import Recaptcha from './Recaptcha';

const Captcha = {
    /**
     * 
     * @param {string} action 
     * 
     * @return {Promise<string>}
     */
    execute: (action) => {
        return Recaptcha.execute(action);
    },

    /**
     * 
     * @param {string} action 
     * 
     * @returns {{token: string, action: string}}
     */
    getPayload: (action) => {
        return Captcha.execute(action).then((token) => {
            return {
                token: token,
                action: action,
            };
        });
    }
};

export default Captcha;
